import { CarouselItem } from "@atoms/carousel-item";
import { Section } from "@atoms/section";
import { Typography } from "@atoms/typography";
import { useFHConfig } from "@templates/config";
import { LayoutTemplate } from "@templates/layout";
import { FC } from "react";

export type BlogArticleTemplateProps = {
  title: string;
  content: string;
  slug: string;
  cover: string;
};
export const BlogArticleTemplate: FC<BlogArticleTemplateProps> = ({
  content,
  cover,
  slug,
  title,
}) => {
  const config = useFHConfig();

  return (
    <LayoutTemplate page="blog">
      <CarouselItem
        imageStandard={`${config.backUrl}/assets/${cover}?fit=cover&width=1400&height=275`}
        imageWebp={`${config.backUrl}/assets/${cover}?fit=cover&width=1400&height=275&format=webp`}
      />
      <Section>
        <Typography variant="title1">{title}</Typography>
        <Typography variant="body1" as="div">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </Typography>
      </Section>
    </LayoutTemplate>
  );
};
